import { render, staticRenderFns } from "./versand.vue?vue&type=template&id=54a29138&"
import script from "./versand.vue?vue&type=script&lang=js&"
export * from "./versand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/83/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a29138')) {
      api.createRecord('54a29138', component.options)
    } else {
      api.reload('54a29138', component.options)
    }
    module.hot.accept("./versand.vue?vue&type=template&id=54a29138&", function () {
      api.rerender('54a29138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/versand.vue"
export default component.exports